import JsBarcode from "jsbarcode";
import * as QRCode from 'qrcode';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { timeout } from "@@/Util";
import { ColorStore } from "../UIComponents/ColorDialog";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const pmake = pdfMake;
pmake.vfs = pdfFonts.pdfMake.vfs;
pmake.fonts = {
    Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
    },
    Bookman: {
        normal: 'Bookman Old Style Regular.ttf',
        bold: 'Bookman Old Style Bold.ttf',
        italics: 'Bookman Old Style Cyr Italic.ttf',
        bolditalics: 'Bookman Old Style Bold Italic.ttf'
    }
};
class State {
    constructor() {
        this.colorstate = new ColorStore();
    }
    async generateAndPrintBarCode(codes, outname, opt, download) {
        var _a, _b, _c, _d, _e, _f;
        const contentstack = [];
        let index = 0;
        for (const bcode of codes) {
            const code = bcode.sid;
            const divid = "barcodeitem";
            const div = document.createElement("div");
            const svg = document.createElement("svg");
            div.style.position = "fixed";
            div.style.left = "-100000px";
            div.style.top = "600px";
            svg.id = divid;
            div.appendChild(svg);
            document.body.appendChild(div);
            svg.style.width = "1000px";
            svg.style.width = "500px";
            let content = [];
            JsBarcode("#" + divid, code, {
                text: code,
                fontOptions: 'bold',
                width: opt.barcodewidth,
                height: opt.barcodeheight
            });
            const tilte = bcode.title;
            const con = div.innerHTML;
            if (tilte) {
                content.push({ text: tilte, alignment: 'center' });
            }
            if (bcode.fldids !== undefined && bcode.fldids.length > 0) {
                for (let i = 0; i < bcode.fldids.length; i++) {
                    const fld = (_a = bcode.fldmap) === null || _a === void 0 ? void 0 : _a.get(bcode.fldids[i]);
                    const fldval = (_c = (_b = bcode.fldvalmap) === null || _b === void 0 ? void 0 : _b.get(bcode.fldids[i])) !== null && _c !== void 0 ? _c : '';
                    if (fld !== undefined && fld.position === 'top') {
                        content.push({ text: (fld.showlabel ? fld.label + ": " : "") + "" + fldval, color: fld.color, fontSize: fld.fontSize, bold: fld.fontStyle === 'bold', alignment: 'center' });
                    }
                }
            }
            content.push({ svg: con, alignment: 'center' });
            if (bcode.fldids !== undefined && bcode.fldids.length > 0) {
                for (let i = 0; i < bcode.fldids.length; i++) {
                    const fld = (_d = bcode.fldmap) === null || _d === void 0 ? void 0 : _d.get(bcode.fldids[i]);
                    const fldval = (_f = (_e = bcode.fldvalmap) === null || _e === void 0 ? void 0 : _e.get(bcode.fldids[i])) !== null && _f !== void 0 ? _f : '';
                    if (fld !== undefined && fld.position === 'bottom') {
                        content.push({ text: (fld.showlabel ? fld.label + ": " : "") + "" + fldval, color: fld.color, fontSize: fld.fontSize, bold: fld.fontStyle === 'bold', alignment: 'center' });
                    }
                }
            }
            content.push({ text: '', marginTop: 70 });
            contentstack.push({ stack: content, unbreakable: true });
            div.remove();
            index++;
            if (index % 1000 === 0) {
                await timeout(10);
            }
        }
        const docde = {
            content: contentstack,
        };
        if (opt.pageheight && opt.pagewidth) {
            docde['pageSize'] = {
                width: opt.pageheight,
                height: opt.pageheight
            };
        }
        else {
            docde['pageSize'] = 'A4';
        }
        if (download) {
            pdfMake.createPdf(docde).download(outname + "-barcodes.pdf", () => {
            });
        }
        else {
            pdfMake.createPdf(docde).print({});
        }
    }
    async printUrlQRCode(url, name, title) {
        const div = document.createElement("div");
        const svg = document.createElement("canvas");
        div.style.position = "fixed";
        div.style.left = "-100000px";
        div.style.top = "600px";
        div.appendChild(svg);
        document.body.appendChild(div);
        div.id = "qrcodeurl";
        const dt = await QRCode.toDataURL(svg, url);
        const content = [];
        if (title) {
            content.push({ text: title, alignment: 'center' });
        }
        content.push({ image: dt, alignment: 'center' });
        content.push({ text: '', marginTop: 70 });
        div.remove();
        const docde = {
            content: content,
            pageSize: 'A1'
        };
        pdfMake.createPdf(docde).download(name + "-qrcode.pdf", () => {
        });
    }
    async generateAndPrintQRCode(codes, outname) {
        const images = [];
        const content = [];
        let index = 0;
        for (const bcode of codes) {
            const title = bcode.title;
            bcode.title = "";
            const code = JSON.stringify(bcode);
            const div = document.createElement("div");
            const svg = document.createElement("canvas");
            div.style.position = "fixed";
            div.style.left = "-100000px";
            div.style.top = "600px";
            div.appendChild(svg);
            document.body.appendChild(div);
            div.id = bcode.rowid;
            const dt = await QRCode.toDataURL(svg, code);
            if (title) {
                content.push({ text: title, alignment: 'center' });
            }
            content.push({ image: dt, alignment: 'center' });
            content.push({ text: '', marginTop: 70 });
            div.remove();
            index++;
            if (index % 1000 === 0) {
                await timeout(10);
            }
        }
        const docde = {
            content: content,
            pageSize: 'A1'
        };
        pdfMake.createPdf(docde).download(outname + "-qrcodes.pdf", () => {
        });
    }
}
export const BarcodeState = new State();
